"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _product = require("@nucleo/product");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactWaypoint = _interopRequireDefault(require("react-waypoint"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _lodash = require("lodash");
var _excluded = ["height", "width", "resizeMode", "alt", "src", "isLoaded"];
var _jsxFileName = "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Image/lib/Image.js",
  _templateObject,
  _templateObject2,
  _this = void 0,
  _templateObject3,
  _templateObject4,
  _templateObject5;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_1gu61d0tok() {
  var path = "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Image/lib/Image.js";
  var hash = "a9c89d15574de87751bfd9d6f91907133fb825ac";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Image/lib/Image.js",
    statementMap: {
      "0": {
        start: {
          line: 13,
          column: 18
        },
        end: {
          line: 13,
          column: 34
        }
      },
      "1": {
        start: {
          line: 15,
          column: 15
        },
        end: {
          line: 23,
          column: 1
        }
      },
      "2": {
        start: {
          line: 25,
          column: 14
        },
        end: {
          line: 44,
          column: 1
        }
      },
      "3": {
        start: {
          line: 39,
          column: 4
        },
        end: {
          line: 43,
          column: 3
        }
      },
      "4": {
        start: {
          line: 46,
          column: 21
        },
        end: {
          line: 115,
          column: 1
        }
      },
      "5": {
        start: {
          line: 50,
          column: 8
        },
        end: {
          line: 50,
          column: 25
        }
      },
      "6": {
        start: {
          line: 53,
          column: 10
        },
        end: {
          line: 55,
          column: 12
        }
      },
      "7": {
        start: {
          line: 64,
          column: 28
        },
        end: {
          line: 64,
          column: 39
        }
      },
      "8": {
        start: {
          line: 65,
          column: 29
        },
        end: {
          line: 65,
          column: 41
        }
      },
      "9": {
        start: {
          line: 67,
          column: 39
        },
        end: {
          line: 67,
          column: 67
        }
      },
      "10": {
        start: {
          line: 68,
          column: 38
        },
        end: {
          line: 68,
          column: 54
        }
      },
      "11": {
        start: {
          line: 76,
          column: 12
        },
        end: {
          line: 80,
          column: 13
        }
      },
      "12": {
        start: {
          line: 88,
          column: 28
        },
        end: {
          line: 88,
          column: 39
        }
      },
      "13": {
        start: {
          line: 89,
          column: 29
        },
        end: {
          line: 89,
          column: 41
        }
      },
      "14": {
        start: {
          line: 91,
          column: 39
        },
        end: {
          line: 91,
          column: 67
        }
      },
      "15": {
        start: {
          line: 92,
          column: 38
        },
        end: {
          line: 92,
          column: 54
        }
      },
      "16": {
        start: {
          line: 106,
          column: 12
        },
        end: {
          line: 110,
          column: 13
        }
      },
      "17": {
        start: {
          line: 117,
          column: 20
        },
        end: {
          line: 122,
          column: 1
        }
      },
      "18": {
        start: {
          line: 121,
          column: 29
        },
        end: {
          line: 121,
          column: 58
        }
      },
      "19": {
        start: {
          line: 125,
          column: 21
        },
        end: {
          line: 139,
          column: 3
        }
      },
      "20": {
        start: {
          line: 141,
          column: 24
        },
        end: {
          line: 151,
          column: 3
        }
      },
      "21": {
        start: {
          line: 153,
          column: 10
        },
        end: {
          line: 158,
          column: 3
        }
      },
      "22": {
        start: {
          line: 160,
          column: 17
        },
        end: {
          line: 163,
          column: 3
        }
      },
      "23": {
        start: {
          line: 161,
          column: 4
        },
        end: {
          line: 161,
          column: 73
        }
      },
      "24": {
        start: {
          line: 162,
          column: 4
        },
        end: {
          line: 162,
          column: 24
        }
      },
      "25": {
        start: {
          line: 165,
          column: 18
        },
        end: {
          line: 168,
          column: 3
        }
      },
      "26": {
        start: {
          line: 166,
          column: 4
        },
        end: {
          line: 166,
          column: 73
        }
      },
      "27": {
        start: {
          line: 167,
          column: 4
        },
        end: {
          line: 167,
          column: 25
        }
      },
      "28": {
        start: {
          line: 170,
          column: 18
        },
        end: {
          line: 176,
          column: 3
        }
      },
      "29": {
        start: {
          line: 171,
          column: 4
        },
        end: {
          line: 171,
          column: 29
        }
      },
      "30": {
        start: {
          line: 173,
          column: 4
        },
        end: {
          line: 175,
          column: 7
        }
      },
      "31": {
        start: {
          line: 189,
          column: 8
        },
        end: {
          line: 189,
          column: 18
        }
      },
      "32": {
        start: {
          line: 191,
          column: 41
        },
        end: {
          line: 191,
          column: 51
        }
      },
      "33": {
        start: {
          line: 193,
          column: 21
        },
        end: {
          line: 193,
          column: 40
        }
      },
      "34": {
        start: {
          line: 195,
          column: 4
        },
        end: {
          line: 225,
          column: 6
        }
      },
      "35": {
        start: {
          line: 201,
          column: 27
        },
        end: {
          line: 201,
          column: 83
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 38,
            column: 4
          },
          end: {
            line: 38,
            column: 5
          }
        },
        loc: {
          start: {
            line: 39,
            column: 4
          },
          end: {
            line: 43,
            column: 3
          }
        },
        line: 39
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 49,
            column: 13
          },
          end: {
            line: 49,
            column: 14
          }
        },
        loc: {
          start: {
            line: 50,
            column: 8
          },
          end: {
            line: 50,
            column: 25
          }
        },
        line: 50
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 52,
            column: 19
          },
          end: {
            line: 52,
            column: 20
          }
        },
        loc: {
          start: {
            line: 53,
            column: 10
          },
          end: {
            line: 55,
            column: 12
          }
        },
        line: 53
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 64,
            column: 19
          },
          end: {
            line: 64,
            column: 20
          }
        },
        loc: {
          start: {
            line: 64,
            column: 28
          },
          end: {
            line: 64,
            column: 39
          }
        },
        line: 64
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 65,
            column: 20
          },
          end: {
            line: 65,
            column: 21
          }
        },
        loc: {
          start: {
            line: 65,
            column: 29
          },
          end: {
            line: 65,
            column: 41
          }
        },
        line: 65
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 67,
            column: 30
          },
          end: {
            line: 67,
            column: 31
          }
        },
        loc: {
          start: {
            line: 67,
            column: 39
          },
          end: {
            line: 67,
            column: 67
          }
        },
        line: 67
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 68,
            column: 29
          },
          end: {
            line: 68,
            column: 30
          }
        },
        loc: {
          start: {
            line: 68,
            column: 38
          },
          end: {
            line: 68,
            column: 54
          }
        },
        line: 68
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 75,
            column: 12
          },
          end: {
            line: 75,
            column: 13
          }
        },
        loc: {
          start: {
            line: 76,
            column: 12
          },
          end: {
            line: 80,
            column: 13
          }
        },
        line: 76
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 88,
            column: 19
          },
          end: {
            line: 88,
            column: 20
          }
        },
        loc: {
          start: {
            line: 88,
            column: 28
          },
          end: {
            line: 88,
            column: 39
          }
        },
        line: 88
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 89,
            column: 20
          },
          end: {
            line: 89,
            column: 21
          }
        },
        loc: {
          start: {
            line: 89,
            column: 29
          },
          end: {
            line: 89,
            column: 41
          }
        },
        line: 89
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 91,
            column: 30
          },
          end: {
            line: 91,
            column: 31
          }
        },
        loc: {
          start: {
            line: 91,
            column: 39
          },
          end: {
            line: 91,
            column: 67
          }
        },
        line: 91
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 92,
            column: 29
          },
          end: {
            line: 92,
            column: 30
          }
        },
        loc: {
          start: {
            line: 92,
            column: 38
          },
          end: {
            line: 92,
            column: 54
          }
        },
        line: 92
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 105,
            column: 12
          },
          end: {
            line: 105,
            column: 13
          }
        },
        loc: {
          start: {
            line: 106,
            column: 12
          },
          end: {
            line: 110,
            column: 13
          }
        },
        line: 106
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 121,
            column: 20
          },
          end: {
            line: 121,
            column: 21
          }
        },
        loc: {
          start: {
            line: 121,
            column: 29
          },
          end: {
            line: 121,
            column: 58
          }
        },
        line: 121
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 146,
            column: 12
          },
          end: {
            line: 146,
            column: 13
          }
        },
        loc: {
          start: {
            line: 146,
            column: 18
          },
          end: {
            line: 146,
            column: 20
          }
        },
        line: 146
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 147,
            column: 13
          },
          end: {
            line: 147,
            column: 14
          }
        },
        loc: {
          start: {
            line: 147,
            column: 19
          },
          end: {
            line: 147,
            column: 21
          }
        },
        line: 147
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 150,
            column: 21
          },
          end: {
            line: 150,
            column: 22
          }
        },
        loc: {
          start: {
            line: 150,
            column: 27
          },
          end: {
            line: 150,
            column: 29
          }
        },
        line: 150
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 160,
            column: 17
          },
          end: {
            line: 160,
            column: 18
          }
        },
        loc: {
          start: {
            line: 160,
            column: 23
          },
          end: {
            line: 163,
            column: 3
          }
        },
        line: 160
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 165,
            column: 18
          },
          end: {
            line: 165,
            column: 19
          }
        },
        loc: {
          start: {
            line: 165,
            column: 24
          },
          end: {
            line: 168,
            column: 3
          }
        },
        line: 165
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 170,
            column: 18
          },
          end: {
            line: 170,
            column: 19
          }
        },
        loc: {
          start: {
            line: 170,
            column: 48
          },
          end: {
            line: 176,
            column: 3
          }
        },
        line: 170
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 178,
            column: 2
          },
          end: {
            line: 178,
            column: 3
          }
        },
        loc: {
          start: {
            line: 178,
            column: 11
          },
          end: {
            line: 226,
            column: 3
          }
        },
        line: 178
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 201,
            column: 21
          },
          end: {
            line: 201,
            column: 22
          }
        },
        loc: {
          start: {
            line: 201,
            column: 27
          },
          end: {
            line: 201,
            column: 83
          }
        },
        line: 201
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 39,
            column: 4
          },
          end: {
            line: 43,
            column: 3
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 39,
            column: 4
          },
          end: {
            line: 39,
            column: 18
          }
        }, {
          start: {
            line: 40,
            column: 4
          },
          end: {
            line: 43,
            column: 3
          }
        }],
        line: 39
      },
      "1": {
        loc: {
          start: {
            line: 52,
            column: 22
          },
          end: {
            line: 52,
            column: 39
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 52,
            column: 37
          },
          end: {
            line: 52,
            column: 39
          }
        }],
        line: 52
      },
      "2": {
        loc: {
          start: {
            line: 67,
            column: 39
          },
          end: {
            line: 67,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 67,
            column: 39
          },
          end: {
            line: 67,
            column: 44
          }
        }, {
          start: {
            line: 67,
            column: 48
          },
          end: {
            line: 67,
            column: 67
          }
        }],
        line: 67
      },
      "3": {
        loc: {
          start: {
            line: 76,
            column: 12
          },
          end: {
            line: 80,
            column: 13
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 76,
            column: 12
          },
          end: {
            line: 76,
            column: 26
          }
        }, {
          start: {
            line: 77,
            column: 12
          },
          end: {
            line: 80,
            column: 13
          }
        }],
        line: 76
      },
      "4": {
        loc: {
          start: {
            line: 91,
            column: 39
          },
          end: {
            line: 91,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 91,
            column: 39
          },
          end: {
            line: 91,
            column: 44
          }
        }, {
          start: {
            line: 91,
            column: 48
          },
          end: {
            line: 91,
            column: 67
          }
        }],
        line: 91
      },
      "5": {
        loc: {
          start: {
            line: 106,
            column: 12
          },
          end: {
            line: 110,
            column: 13
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 106,
            column: 12
          },
          end: {
            line: 106,
            column: 26
          }
        }, {
          start: {
            line: 107,
            column: 12
          },
          end: {
            line: 110,
            column: 13
          }
        }],
        line: 106
      },
      "6": {
        loc: {
          start: {
            line: 197,
            column: 9
          },
          end: {
            line: 197,
            column: 59
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 197,
            column: 9
          },
          end: {
            line: 197,
            column: 20
          }
        }, {
          start: {
            line: 197,
            column: 24
          },
          end: {
            line: 197,
            column: 59
          }
        }],
        line: 197
      },
      "7": {
        loc: {
          start: {
            line: 203,
            column: 11
          },
          end: {
            line: 222,
            column: 13
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 203,
            column: 11
          },
          end: {
            line: 203,
            column: 25
          }
        }, {
          start: {
            line: 204,
            column: 12
          },
          end: {
            line: 204,
            column: 21
          }
        }, {
          start: {
            line: 205,
            column: 14
          },
          end: {
            line: 221,
            column: 20
          }
        }],
        line: 203
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0
    },
    b: {
      "0": [0, 0],
      "1": [0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a9c89d15574de87751bfd9d6f91907133fb825ac"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1gu61d0tok = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1gu61d0tok();
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var _ref = (cov_1gu61d0tok().s[0]++, _stylingConstants.default),
  color = _ref.color;
var Figure = (cov_1gu61d0tok().s[1]++, _styledComponents.default.figure.attrs({
  className: 'g-Figure'
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  box-sizing: border-box;\n  display: block;\n  margin: 0 auto;\n  width: 100%;\n"]))));
var Inner = (cov_1gu61d0tok().s[2]++, _styledComponents.default.div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  box-sizing: border-box;\n  display: block;\n  background: ", "\n    url(data:image/svg+xml,%0A%3Csvg%20fill%3D%22%23d5dde8%22%20height%3D%2248%22%20viewBox%3D%220%200%2024%2024%22%20width%3D%2248%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M0%200h24v24H0z%22%20fill%3D%22none%22/%3E%0A%20%20%20%20%3Cpath%20d%3D%22M21%2019V5c0-1.1-.9-2-2-2H5c-1.1%200-2%20.9-2%202v14c0%201.1.9%202%202%202h14c1.1%200%202-.9%202-2zM8.5%2013.5l2.5%203.01L14.5%2012l4.5%206H5l3.5-4.5z%22/%3E%0A%3C/svg%3E)\n    no-repeat center center;\n\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n\n  ", ";\n"])), color.disabledBackground, function (props) {
  cov_1gu61d0tok().f[0]++;
  cov_1gu61d0tok().s[3]++;
  return (cov_1gu61d0tok().b[0][0]++, props.isLoaded) && (cov_1gu61d0tok().b[0][1]++, "\n    background: transparent;\n    transition: background 0.25s 1s;\n  ");
}));
var ImageWrapper = (cov_1gu61d0tok().s[4]++, (0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)((0, _utils.withThemedStyles)((0, _styledComponents.default)(function (_ref2) {
  var height = _ref2.height,
    width = _ref2.width,
    resizeMode = _ref2.resizeMode,
    alt = _ref2.alt,
    src = _ref2.src,
    isLoaded = _ref2.isLoaded,
    rest = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  cov_1gu61d0tok().f[1]++;
  cov_1gu61d0tok().s[5]++;
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, rest, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 50,
      columnNumber: 9
    }
  }));
}).attrs({
  className: function className(_ref3) {
    var _ref3$themeQueries = _ref3.themeQueries,
      themeQueries = _ref3$themeQueries === void 0 ? (cov_1gu61d0tok().b[1][0]++, {}) : _ref3$themeQueries;
    cov_1gu61d0tok().f[2]++;
    cov_1gu61d0tok().s[6]++;
    return (0, _utils.classNames)({
      'stx-ImageWrapper': themeQueries.EVOLUTION
    });
  }
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n          position: absolute;\n          box-sizing: border-box;\n          display: block;\n          top: 0;\n          left: 0;\n          width: ", ";\n          height: ", ";\n          backface-visibility: hidden;\n          background-image: ", ";\n          background-size: ", ";\n          background-repeat: no-repeat;\n          background-position: 50% 50%;\n          opacity: 0;\n          will-change: opacity;\n          transition: opacity 0.35s 0.25s;\n\n          ", ";\n        "])), function (props) {
  cov_1gu61d0tok().f[3]++;
  cov_1gu61d0tok().s[7]++;
  return props.width;
}, function (props) {
  cov_1gu61d0tok().f[4]++;
  cov_1gu61d0tok().s[8]++;
  return props.height;
}, function (props) {
  cov_1gu61d0tok().f[5]++;
  cov_1gu61d0tok().s[9]++;
  return (cov_1gu61d0tok().b[2][0]++, props) && (cov_1gu61d0tok().b[2][1]++, "url(".concat(props.src, ")"));
}, function (props) {
  cov_1gu61d0tok().f[6]++;
  cov_1gu61d0tok().s[10]++;
  return props.resizeMode;
}, function (props) {
  cov_1gu61d0tok().f[7]++;
  cov_1gu61d0tok().s[11]++;
  return (cov_1gu61d0tok().b[3][0]++, props.isLoaded) && (cov_1gu61d0tok().b[3][1]++, "\n              visibility: visible;\n              opacity: 1;\n            ");
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n          position: absolute;\n          box-sizing: border-box;\n          display: block;\n          top: 0;\n          left: 0;\n          width: ", ";\n          height: ", ";\n          backface-visibility: hidden;\n          background-image: ", ";\n          background-size: ", ";\n          background-repeat: no-repeat;\n          background-position: 50% 50%;\n          opacity: 0;\n          will-change: opacity, transform;\n          transition: opacity 0.35s 0.25s,\n            transform ", " ease-in-out;\n\n          &:hover {\n            transform: scale(", ");\n          }\n          border-radius: var(--generalBorderRadius, 12px);\n\n          ", ";\n        "])), function (props) {
  cov_1gu61d0tok().f[8]++;
  cov_1gu61d0tok().s[12]++;
  return props.width;
}, function (props) {
  cov_1gu61d0tok().f[9]++;
  cov_1gu61d0tok().s[13]++;
  return props.height;
}, function (props) {
  cov_1gu61d0tok().f[10]++;
  cov_1gu61d0tok().s[14]++;
  return (cov_1gu61d0tok().b[4][0]++, props) && (cov_1gu61d0tok().b[4][1]++, "url(".concat(props.src, ")"));
}, function (props) {
  cov_1gu61d0tok().f[11]++;
  cov_1gu61d0tok().s[15]++;
  return props.resizeMode;
}, (0, _lodash.get)(_themeMapper.evolutionTheme, 'image.interactiveTime', '100ms'), (0, _lodash.get)(_themeMapper.evolutionTheme, 'image.interactiveScale', 1.05), function (props) {
  cov_1gu61d0tok().f[12]++;
  cov_1gu61d0tok().s[16]++;
  return (cov_1gu61d0tok().b[5][0]++, props.isLoaded) && (cov_1gu61d0tok().b[5][1]++, "\n              visibility: visible;\n              opacity: 1;\n            ");
}))))));
var AspectRatio = (cov_1gu61d0tok().s[17]++, _styledComponents.default.div.attrs({
  className: 'g-Image-AspectRatio'
})(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  padding-bottom: ", ";\n"])), function (props) {
  cov_1gu61d0tok().f[13]++;
  cov_1gu61d0tok().s[18]++;
  return "".concat(1 / props.ratio * 100, "%");
}));
var Image = /*#__PURE__*/function (_PureComponent) {
  function Image() {
    var _this2;
    (0, _classCallCheck2.default)(this, Image);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, Image, [].concat(args));
    (0, _defineProperty2.default)(_this2, "state", (cov_1gu61d0tok().s[21]++, {
      isLoading: false,
      hasError: false,
      isLoaded: false,
      canRenderImage: false
    }));
    (0, _defineProperty2.default)(_this2, "handleOnLoad", (cov_1gu61d0tok().s[22]++, function () {
      cov_1gu61d0tok().f[17]++;
      cov_1gu61d0tok().s[23]++;
      _this2.setState({
        isLoading: false,
        isLoaded: true,
        hasError: false
      });
      cov_1gu61d0tok().s[24]++;
      _this2.props.onLoad();
    }));
    (0, _defineProperty2.default)(_this2, "handleOnError", (cov_1gu61d0tok().s[25]++, function () {
      cov_1gu61d0tok().f[18]++;
      cov_1gu61d0tok().s[26]++;
      _this2.setState({
        isLoading: false,
        isLoaded: false,
        hasError: true
      });
      cov_1gu61d0tok().s[27]++;
      _this2.props.onError();
    }));
    (0, _defineProperty2.default)(_this2, "handleOnEnter", (cov_1gu61d0tok().s[28]++, function (product, onEnterViewPort) {
      cov_1gu61d0tok().f[19]++;
      cov_1gu61d0tok().s[29]++;
      onEnterViewPort(product);
      cov_1gu61d0tok().s[30]++;
      _this2.setState({
        canRenderImage: true
      });
    }));
    return _this2;
  }
  (0, _inherits2.default)(Image, _PureComponent);
  return (0, _createClass2.default)(Image, [{
    key: "render",
    value: function render() {
      var _this3 = this;
      cov_1gu61d0tok().f[20]++;
      var _ref4 = (cov_1gu61d0tok().s[31]++, this.props),
        alt = _ref4.alt,
        src = _ref4.src,
        resizeMode = _ref4.resizeMode,
        height = _ref4.height,
        width = _ref4.width,
        aspectRatio = _ref4.aspectRatio,
        title = _ref4.title,
        productForDataLayer = _ref4.productForDataLayer,
        onEnterViewPort = _ref4.onEnterViewPort;
      var _ref5 = (cov_1gu61d0tok().s[32]++, this.state),
        isLoaded = _ref5.isLoaded,
        canRenderImage = _ref5.canRenderImage;
      var hasError = (cov_1gu61d0tok().s[33]++, this.state.hasError);
      cov_1gu61d0tok().s[34]++;
      return /*#__PURE__*/_react.default.createElement(Figure, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 196,
          columnNumber: 7
        }
      }, (cov_1gu61d0tok().b[6][0]++, aspectRatio) && (cov_1gu61d0tok().b[6][1]++, /*#__PURE__*/_react.default.createElement(AspectRatio, {
        ratio: aspectRatio,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 197,
          columnNumber: 25
        }
      })), /*#__PURE__*/_react.default.createElement(Inner, {
        isLoaded: isLoaded,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 198,
          columnNumber: 9
        }
      }, /*#__PURE__*/_react.default.createElement(_reactWaypoint.default, {
        scrollableAncestor: window,
        onEnter: function onEnter() {
          cov_1gu61d0tok().f[21]++;
          cov_1gu61d0tok().s[35]++;
          return _this3.handleOnEnter(productForDataLayer, onEnterViewPort);
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 199,
          columnNumber: 11
        }
      }), (cov_1gu61d0tok().b[7][0]++, canRenderImage) && (cov_1gu61d0tok().b[7][1]++, !hasError) && (cov_1gu61d0tok().b[7][2]++, /*#__PURE__*/_react.default.createElement("div", {
        className: "g-Figure-ImageContainer",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 205,
          columnNumber: 15
        }
      }, /*#__PURE__*/_react.default.createElement("img", {
        style: {
          display: 'none'
        },
        src: src,
        onLoad: this.handleOnLoad,
        onError: this.handleOnError,
        alt: alt,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 206,
          columnNumber: 17
        }
      }), /*#__PURE__*/_react.default.createElement(ImageWrapper, {
        isLoaded: isLoaded,
        resizeMode: resizeMode,
        height: height,
        width: width,
        title: title,
        src: src,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 213,
          columnNumber: 17
        }
      })))));
    }
  }]);
}(_react.PureComponent);
(0, _defineProperty2.default)(Image, "propTypes", (cov_1gu61d0tok().s[19]++, {
  alt: _propTypes.default.string.isRequired,
  src: _propTypes.default.string.isRequired,
  height: _propTypes.default.string,
  width: _propTypes.default.string,
  aspectRatio: _propTypes.default.number,
  resizeMode: _propTypes.default.oneOf(['fill', 'contain', 'cover', 'none']),
  onLoad: _propTypes.default.func,
  onError: _propTypes.default.func,
  title: _propTypes.default.string,
  /** Product that contains data object to push to dataLayer */
  productForDataLayer: _product.ProductType,
  /** Function to handle when image is in view port */
  onEnterViewPort: _propTypes.default.func
}));
(0, _defineProperty2.default)(Image, "defaultProps", (cov_1gu61d0tok().s[20]++, {
  resizeMode: 'cover',
  height: '100%',
  width: '100%',
  aspectRatio: 1,
  onLoad: function onLoad() {
    cov_1gu61d0tok().f[14]++;
  },
  onError: function onError() {
    cov_1gu61d0tok().f[15]++;
  },
  title: undefined,
  productForDataLayer: undefined,
  onEnterViewPort: function onEnterViewPort() {
    cov_1gu61d0tok().f[16]++;
  }
}));
var _default = exports.default = Image;